module.exports = __webpack_public_path__ + "static/media/trasmetal.481db70d.png";